import ReactDOM from "react-dom/client";
import App from './App';
// import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap/dist/css/bootstrap.min.css';

import './design-system.css';
import './asstes/css/sass/style.scss';
import './asstes/css/sass/responsive.scss';
import './asstes/css/sass/departments.scss';
import GoogleTag from "./Canada/Component/GoogleTag.jsx";
// import { hydrate, render } from "react-dom";

import "bootstrap/dist/js/bootstrap.bundle.min.js";

// const rootElement = document.getElementById("root");
// if (rootElement.hasChildNodes()) {
//   hydrate(<App />, rootElement);
// } else {
//   render(<App />, rootElement);
// }
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<>
<GoogleTag/>

     <App />
</>
);
